const routes = [];

export function registerRoute(pattern, handler) {
  routes.push({ pattern, handler });
}

export function navigate(path) {
  if (path !== window.location.pathname + window.location.search) {
    window.history.pushState({ internal: true }, "", path);
  }
  resolve();
}

/** Go back when the previous entry is one of ours, else navigate to `fallback`. */
export function goBack(fallback) {
  if (window.history.state?.internal) window.history.back();
  else navigate(fallback);
}

/** Replace the current query string without pushing history (used by filters). */
export function replaceQuery(params) {
  const url = new URL(window.location.href);
  url.search = "";
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== "" && v !== false) url.searchParams.set(k, String(v));
  }
  window.history.replaceState(window.history.state ?? {}, "", url.pathname + url.search);
}

export function parseQuery(search) {
  const out = {};
  new URLSearchParams(search || "").forEach((v, k) => {
    out[k] = v;
  });
  return out;
}

function findRoute(pathname) {
  for (const route of routes) {
    const match = pathname.match(route.pattern);
    if (match) return { route, match };
  }
  return null;
}

let renderToken = 0;

async function resolve() {
  const root = document.getElementById("app");
  if (!root) return;
  const token = ++renderToken;
  const pathname = window.location.pathname || "/";
  const found = findRoute(pathname);
  window.scrollTo({ top: 0, behavior: "instant" });
  if (!found) {
    root.innerHTML = `<section class="empty"><h2>Página não encontrada</h2><p><a href="/" data-link>Voltar para o início</a></p></section>`;
    document.title = "Não encontrado · Como Vota";
    return;
  }
  root.innerHTML = `<div class="banner banner--loading">Carregando…</div>`;
  try {
    await found.route.handler({
      root,
      match: found.match,
      search: window.location.search,
      query: parseQuery(window.location.search),
      isCurrent: () => token === renderToken,
    });
  } catch (err) {
    console.error(err);
    if (token !== renderToken) return;
    root.innerHTML = `<section class="empty"><h2>Erro ao carregar</h2><p class="banner banner--error">${escapeHtml(
      err.message || String(err),
    )}</p><p><a href="/" data-link>Voltar para o início</a></p></section>`;
  }
}

function isInternalLink(anchor) {
  return (
    anchor &&
    anchor.tagName === "A" &&
    anchor.hasAttribute("data-link") &&
    anchor.target !== "_blank" &&
    !anchor.hasAttribute("download")
  );
}

export function startRouter() {
  document.addEventListener("click", (e) => {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const anchor = e.target.closest("a");
    if (!isInternalLink(anchor)) return;
    const href = anchor.getAttribute("href");
    if (!href || href.startsWith("http") || href.startsWith("//") || href.startsWith("mailto:")) return;
    e.preventDefault();
    navigate(href);
  });
  window.addEventListener("popstate", resolve);
  resolve();
}

export function escapeHtml(s) {
  if (s == null) return "";
  return String(s)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}
